<template>
  <section class="has-background-grey p-5">
    <div class="container is-max-desktop">
      <div class="columns is-multiline">
        <div class="column">
          <header>
            <h1 class="has-gob-title">Sucursales</h1>
            <span class="is-lower-text-title">Busca fácilmente dónde recibir atención.</span>
          </header>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'HeaderComponent'
}
</script>